// link to documentation: https://www.highcharts.com/demo/highcharts/line-chart

import formatDateLabel from '../methods/utils/formatDateLabel';
import ticksGetFirstDayForEachYear from '../methods/ticks/ticksGetFirstDayForEachYear';
import formatYAxisLabel from "../methods/utils/formatYAxisLabel"


export default function (props) {
    customFormatForForecast(props) 

    const forecastLabel = props.forecastSplitLabel && props.forecastSplitLabel !== "" 
        ? props.forecastSplitLabel 
        : new Date(props.forecastSplitDate).toLocaleDateString('da-DK', { day: '2-digit', month: 'short', year: 'numeric' })

    return {
        chart: {
            type: "line",
        },
        title: {
            text: props.title,
            align: 'left',

        },
        subtitle: {
            text: props.subtitle,
            align: 'left',
        },
        yAxis: {
            title: {
                text: props.yaxisTitle
            },
            labels: {
                formatter: function () {
                    return `${formatYAxisLabel(this.value, props.yAxisDecimals)}${props.yaxisLabelFormat}`;
                }
            },
            accessibility: {
                description: props.accaccessibilityDescriptionYaxis
            }
        },
        xAxis: {
            type: "datetime",
            plotLines: [{
                color: '#000000',
                width: 2,
                value: props.forecastSplitDate,
                zIndex: 2,
                dashStyle: 'Dash',
                label: {
                    text: forecastLabel,
                    rotation: 0,
                    y: 20,
                    style: {
                        fontSize: 12,
                        color: '#000000'
                    }
                }
            }],
            title: {
                text: props.xaxisTitle
            },
            accessibility: {
                description: props.accaccessibilityDescriptionXaxis,
                rangeDescription: props.accaccessibilityRangeDescriptionXaxis
            },
            // handle this within a logic function
            categories: props.categories,
            tickPositioner: function () {
                return ticksGetFirstDayForEachYear(this)
            },

            labels: {
                formatter: function () {
                    return formatDateLabel(this.value)
                }
            }
        },
        tooltip: {
            shared: true,
            crosshairs: true,
            valueSuffix: props.tooltipValueSuffix,
            useHTML: true,

            formatter: function () {
                const date = new Date(this.x);
                const formattedDate = date.toLocaleDateString('da-DK', {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit'
                });

                let tooltip = `<table><tr><th colspan="2">${formattedDate}</th></tr>`;
                this.points.forEach(point => {
                    tooltip += `<tr>
                    <td><span style="color:${point.color}">\u25CF</span> ${point.series.name}: </td>
                    <td style="text-align: right"><b>${formatYAxisLabel(point.y, props.yAxisDecimals)} ${props.tooltipValueSuffix}</b></td>
                    </tr>`;
                });
                tooltip += `</table>`;
                return tooltip;
            },

        },
        colors: props.colors,
        series: props.seriesData,
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    xAxis: {
                        tickPositioner: function () {
                            return [this.dataMin, this.dataMax];
                        }
                    }
                }
            }]
        }
    }
}

function customFormatForForecast(props) {
    const categoriesDateTimeInt = []
    const formattedCategories = []
    props.categories.map((category) => {
        const match = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/.exec(category)
        let date
        if (match) {
            const [ , day, month, year ] = match
            date = new Date(`${year}-${month}-${day}`)
        } else {
            date = new Date(category)
        }
        categoriesDateTimeInt.push(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
        formattedCategories.push(formatDateLabel(category))
    })

    props.categories = formattedCategories
    props.seriesData.forEach((serie) => {
        const data = []
        serie.data.map((item, index) => {
            data.push([categoriesDateTimeInt[index], item])
        })

        serie.pointInterval = 7 * 24 * 36e5,
        serie.data = data
        serie.zoneAxis = 'x'
        serie.zones = [{
            value: props.forecastSplitDate,
            dashStyle: 'Solid'
        }, {
            dashStyle: 'Dot'
        }]
    })
}